<template>
  <PButton
    class="flex items-center justify-center rounded-full font-semibold"
    :disabled="is_disabled || is_loading || null"
    :size="size"
    @click.stop="submit"
  >
    <div
      v-if="iconFontawesome || is_loading"
      class="flex items-center justify-center"
    >
      <FontAwesomeIcon
        v-if="!is_loading"
        :icon="iconFontawesome"
      />
      <FontAwesomeIcon
        v-else
        icon="spinner"
        pulse
      />
    </div>
    <div>
      <slot
        v-if="is_loading"
        name="loadingText"
      >
        {{ $t('button.actions.loading') }}
      </slot>
      <slot v-else />
    </div>
  </PButton>
</template>

<script>
const actions_to_fontawesome_icon = Object.freeze({
  approve: 'check',
  create: 'plus',
  download: 'download',
  invitation: 'envelope',
  new: 'plus',
  move: 'shuffle',
  publish: ['far', 'eye'],
  save: ['far', 'floppy-disk'],
  send: 'paper-plane',
  share: 'share',
  sign: ['far', 'signature'],
  unpublish: ['far', 'eye-slash'],
  update: 'save',
  upload: 'upload',
  unlock: ['far', 'unlock'],
  info: ['far', 'circle-info'],
});

export default {
  name: 'ButtonPrimary',
  props: {
    action: {
      type: String,
      default: null,
      validator: (prop) => Object.keys(actions_to_fontawesome_icon).includes(prop),
    },
    is_disabled: { type: Boolean },
    is_loading: { type: Boolean },
    to: { type: Object, default: null },
    size: { type: String, default: 'small' },
  },

  emits: ['onClick'],

  data() {
    return {
      iconFontawesome: null,
    };
  },

  created() {
    this.iconFontawesome = actions_to_fontawesome_icon[this.action];
  },

  methods: {
    submit() {
      if (this.is_loading || this.is_disabled) return;
      if (this.to) {
        this.$router.push(this.to);
        return;
      }
      this.$emit('onClick');
    },
  },
};
</script>
